/**
 * LegalAcceptanceCheckbox — un solo checkbox que cubre los 4 documentos.
 *
 * Si !accepted, el caller debe deshabilitar todos los CTAs (correo +
 * OAuth). Esto fuerza al usuario a marcar consentimiento expreso antes
 * de cualquier acción de auth.
 *
 * Uso:
 *   const [accepted, setAccepted] = useState(false)
 *   <LegalAcceptanceCheckbox
 *     accepted={accepted}
 *     setAccepted={setAccepted}
 *     actionVerb="iniciar sesión"   // o "crear tu cuenta"
 *   />
 *   <button disabled={!accepted}>...</button>
 */

export function LegalAcceptanceCheckbox({
  accepted,
  setAccepted,
  actionVerb,
}: {
  accepted: boolean
  setAccepted: (v: boolean) => void
  actionVerb: string
}) {
  return (
    <label className="mt-5 flex cursor-pointer items-start gap-2.5 rounded-lg border border-border bg-bg-app/40 px-3.5 py-3 text-sm text-fg-primary transition-colors hover:bg-bg-elevated">
      <input
        type="checkbox"
        checked={accepted}
        onChange={(e) => setAccepted(e.target.checked)}
        required
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-border text-brand-600 focus:ring-2 focus:ring-brand-500/20"
      />
      <span className="leading-snug">
        Al {actionVerb} acepto los{' '}
        <a
          href="/legal/terminos"
          target="_blank"
          rel="noreferrer"
          className="font-medium text-brand-600 hover:underline"
        >
          Términos
        </a>
        , la{' '}
        <a
          href="/legal/habeas-data"
          target="_blank"
          rel="noreferrer"
          className="font-medium text-brand-600 hover:underline"
        >
          Autorización Habeas Data
        </a>
        , la{' '}
        <a
          href="/legal/privacidad"
          target="_blank"
          rel="noreferrer"
          className="font-medium text-brand-600 hover:underline"
        >
          Política de Privacidad
        </a>{' '}
        y la{' '}
        <a
          href="/legal/cookies"
          target="_blank"
          rel="noreferrer"
          className="font-medium text-brand-600 hover:underline"
        >
          Política de Cookies
        </a>{' '}
        de Taxor.{' '}
        <span className="text-error-fg">*</span>
      </span>
    </label>
  )
}
